import {
    CacheOptions,
    Configuration,
    IPublicClientApplication,
    PublicClientApplication,
} from "@azure/msal-browser";

export class MsalFactory {
    private static instance: IPublicClientApplication | null = null;
    private cacheConfig: CacheOptions = {
        cacheLocation: "localStorage",
    };

    public async getOrCreateMsalInstance(
        config: Configuration
    ): Promise<IPublicClientApplication> {
        if (MsalFactory.instance) {
            return MsalFactory.instance;
        }

        MsalFactory.instance = new PublicClientApplication({
            ...config,
            cache: { ...config.cache, ...this.cacheConfig },
        });
        await MsalFactory.instance.initialize();

        return MsalFactory.instance;
    }
}
